var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "va-dialog", scrollable: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "va-card",
            [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "div",
                    { staticClass: "va-title d-flex align-center mr-auto" },
                    [
                      _c("i", { staticClass: "vi vi-folder-play mt-1 mr-4" }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("ds.addMediaToPlaylist")) + " "
                      )
                    ]
                  ),
                  _c("va-button", {
                    staticClass: "mt-1",
                    attrs: {
                      color: "secondary",
                      cta: _vm.$t("common.dismiss"),
                      icon: "vi vi-i-remove-1",
                      type: "square"
                    },
                    on: {
                      click: function($event) {
                        _vm.dialog = false
                      }
                    }
                  })
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "rounded row-pointer",
                attrs: {
                  headers: _vm.generateHeaders(_vm.tableConfig, false),
                  items: _vm.items,
                  options: _vm.groupOptions,
                  "server-items-length": _vm.$store.getters["media/totalItems"],
                  "item-key": "ID",
                  loading: _vm.$store.getters["media/loading"],
                  "loading-text": _vm.$t("common.loading"),
                  "footer-props": _vm.$store.getters["media/footerProps"],
                  "multi-sort": "",
                  "mobile-breakpoint": "0"
                },
                on: {
                  "update:options": function($event) {
                    _vm.groupOptions = $event
                  },
                  "click:row": _vm.onChangeMedia
                },
                scopedSlots: _vm._u([
                  {
                    key: "top",
                    fn: function() {
                      return [
                        _c("va-table-top", {
                          model: {
                            value: _vm.searchString,
                            callback: function($$v) {
                              _vm.searchString = $$v
                            },
                            expression: "searchString"
                          }
                        })
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "no-data",
                    fn: function() {
                      return [_c("va-no-data-tag")]
                    },
                    proxy: true
                  },
                  {
                    key: "item.companyMediaId",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("va-button", {
                          staticClass: "mt-1",
                          attrs: {
                            color: "secondary",
                            icon: _vm.isPresent(item)
                              ? "vi vi-d-delete"
                              : "vi vi-d-add",
                            type: "icon"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "item.uploadDate",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("date2string")(item.uploadDate)) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("va-button", {
        staticClass: "mr-4",
        attrs: {
          icon: "vi vi-folder-play",
          type: "outline",
          cta: _vm.$t("ds.addFromMedia")
        },
        on: { click: _vm.openDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }